import axiosClient from '../axiosClient';
import { FETCH_RESOURCE_COMPONENT_API_URL, RESOURCE_COMPONENT_MAPPING_API_URL } from '../constants';

const ResourceComponentManagement = {
  createResourceComponent: async (body: any) => {
    try {
      const response = await axiosClient.post(`${RESOURCE_COMPONENT_MAPPING_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchResourceComponents: async (params: any) => {
    try {
      const response = await axiosClient.get(FETCH_RESOURCE_COMPONENT_API_URL, { params });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  deleteResourceComponent: async (mappingId: string) => {
    try {
      const response = await axiosClient.delete(
        `${RESOURCE_COMPONENT_MAPPING_API_URL}/${mappingId}?mappingId=${mappingId}`,
      );
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
};

export default ResourceComponentManagement;
